import React from "react";
import TableRow from "@material-ui/core/TableRow";

const GetDealRows = (deals, order, columns, callbacks, pathFunction) => order.map(key => (
  <TableRow key={key} hover>
    {columns.map(({ id, Cell }) => (Cell ? <Cell key={id} deal={deals[key]} linkPath={pathFunction} /> : null))}
  </TableRow>
));

export default GetDealRows;
